<template>
  <div>
    <l-tables :tableConfig="tableConfig"  :searchParams='searchData' :noCreatText="noCreatText" :ImgSrc='nullImg' :emptyImgSrc="emptyImgSrc" @tableChange="handleTableHeaderChange">
      <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('semester.inputSemesterName')">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
        </a-input>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('semester.createSemester') }}</a-button>
      </template>
      <template #status="{ record }">
        {{ record.status === '1' ? $t('semester.statusEnabled') : $t('semester.statusDisabled') }}
      </template>
      <template #lessonTime="{ record }">
        {{ record.lessonTime.split(' ').join(' - ') }}
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('semester.createSemester') }}</a-button>
      </template>
    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'

export default {
  components: {
    LTables
  },
  data() {
    return {
      noCreatText: this.$t('semester.noSemester'),
      nullImg: require('@/assets/img/semesterNull.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      keyword: undefined,
      searchData: {
        keyword: ''
      },
      tableConfig: {
        tableName: this.$t('semester.management'),
        tableColumns: [
        {
          title: 'ID',
          dataIndex: 'index',
          key: 'index',
          align: 'center'
        },
        {
          title: this.$t('semester.semesterName'),
          dataIndex: 'semesterName',
          key: 'semesterName',
          align: 'center'
        },
        {
          title: this.$t('semester.startTime'),
          dataIndex: 'startDate',
          key: 'startDate',
          align: 'center'
        },
        {
          title: this.$t('semester.endTime'),
          dataIndex: 'endDate',
          key: 'endDate',
          align: 'center'
        },
        {
          title: this.$t('semester.dailyLessons'),
          dataIndex: 'dailyLessons',
          key: 'dailyLessons',
          align: 'center'
        },
        {
          title: this.$t('semester.lessonTimeRange'),
          dataIndex: 'lessonTime',
          key: 'lessonTime',
          align: 'center',
          scopedSlots: { customRender: 'lessonTime' }
        },
        {
          title: this.$t('semester.operation'),
          dataIndex: 'operate',
          key: 'operate',
          align: 'center',
          scopedSlots: { customRender: 'operate' }
        }
      ],
        tableDeleteTip: {
          title: this.$t('semester.confirmDelete'),
          content: this.$t('semester.deleteNoRecover')
        },
        tablePort: {
          list: '/admin/semester/list'
        },
        // tableData:[],
        tableEditRouteNName: 'semesterAdd'
      }
    }
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    handleTableHeaderChange([filters, getList]) {
      getList()
    },
    create() {
      this.$router.push({
        name: 'semesterAdd'
      })
    }
  }
}
</script>
